import { FORM_ERROR } from 'final-form';
import { useCallback } from 'react';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';
import { ACSC_SYSTEM, EVERI_SYSTEM } from '../constants';

export const useOnSubmit = ({ onSuccess }) => {
    const { system } = useComponentConfig();
    const translate = useComponentTranslations();
    const dynamicReducerDispatch = useDynamicReducerDispatch();

    return useCallback(async ({ pin }) => {
        try {
            await server.linkWallet({
                system,
                pin
            });

            onSuccess();
        } catch (error) {
            const errorActions = error.response.data?.actions;
            const { actionOpenUrlInfo } = errorActions?.find((action) => action.actionOpenUrlInfo) ?? {};
            const { showMessageNotificationInfo } = errorActions?.find((action) => action.showMessageNotificationInfo) ?? {};
            const { openUrl } = actionOpenUrlInfo ?? {};
            const { message } = showMessageNotificationInfo ?? {};

            switch (system) {
                case ACSC_SYSTEM:
                    return {
                        [FORM_ERROR]: message || translate('acsc.error.unable-to-link')
                    };

                case EVERI_SYSTEM:
                    if (openUrl) {
                        dynamicReducerDispatch(actions.setOpenUrl(openUrl));
                        dynamicReducerDispatch(actions.setPin(pin));
                        return;
                    }

                    return {
                        [FORM_ERROR]: message || translate('everi.error.unable-to-link')
                    };

                default:
                    // noop
                    break;
            }
        }
    }, [dynamicReducerDispatch, system, translate, onSuccess]);
};
